import {
  AdminTwitterApiCallsDeleteResponseSchema,
  AdminTwitterApiCallsResponseSchema,
  AdminTwitterFetchTimelineResponseSchema,
  AdminTwitterGraphqlExecuteResponseSchema,
  AdminTwitterGraphqlOperationsResponseSchema,
  AdminTwitterLookupResponseSchema,
  AdminTwitterStatsResponseSchema,
  AdminTwitterUsageResponseSchema,
} from '@sweetistics/contracts';
import type { z } from 'zod';

export type AdminTwitterStatsResponseInput = z.input<typeof AdminTwitterStatsResponseSchema>;
export type AdminTwitterStatsResponseOutput = z.output<typeof AdminTwitterStatsResponseSchema>;

export function serializeAdminTwitterStatsResponse(
  payload: AdminTwitterStatsResponseInput
): AdminTwitterStatsResponseOutput {
  return AdminTwitterStatsResponseSchema.parse(payload);
}

export type AdminTwitterUsageResponseInput = z.input<typeof AdminTwitterUsageResponseSchema>;
export type AdminTwitterUsageResponseOutput = z.output<typeof AdminTwitterUsageResponseSchema>;

export function serializeAdminTwitterUsageResponse(
  payload: AdminTwitterUsageResponseInput
): AdminTwitterUsageResponseOutput {
  return AdminTwitterUsageResponseSchema.parse(payload);
}

export type AdminTwitterLookupResponseInput = z.input<typeof AdminTwitterLookupResponseSchema>;
export type AdminTwitterLookupResponseOutput = z.output<typeof AdminTwitterLookupResponseSchema>;

export function serializeAdminTwitterLookupResponse(
  payload: AdminTwitterLookupResponseInput
): AdminTwitterLookupResponseOutput {
  return AdminTwitterLookupResponseSchema.parse(payload);
}

export type AdminTwitterApiCallsResponseInput = z.input<typeof AdminTwitterApiCallsResponseSchema>;
export type AdminTwitterApiCallsResponseOutput = z.output<typeof AdminTwitterApiCallsResponseSchema>;

export function serializeAdminTwitterApiCallsResponse(
  payload: AdminTwitterApiCallsResponseInput
): AdminTwitterApiCallsResponseOutput {
  return AdminTwitterApiCallsResponseSchema.parse(payload);
}

export type AdminTwitterApiCallsDeleteResponseInput = z.input<typeof AdminTwitterApiCallsDeleteResponseSchema>;
export type AdminTwitterApiCallsDeleteResponseOutput = z.output<typeof AdminTwitterApiCallsDeleteResponseSchema>;

export function serializeAdminTwitterApiCallsDeleteResponse(
  payload: AdminTwitterApiCallsDeleteResponseInput
): AdminTwitterApiCallsDeleteResponseOutput {
  return AdminTwitterApiCallsDeleteResponseSchema.parse(payload);
}

export type AdminTwitterGraphqlOperationsResponseInput = z.input<typeof AdminTwitterGraphqlOperationsResponseSchema>;
export type AdminTwitterGraphqlOperationsResponseOutput = z.output<typeof AdminTwitterGraphqlOperationsResponseSchema>;

export function serializeAdminTwitterGraphqlOperationsResponse(
  payload: AdminTwitterGraphqlOperationsResponseInput
): AdminTwitterGraphqlOperationsResponseOutput {
  return AdminTwitterGraphqlOperationsResponseSchema.parse(payload);
}

export type AdminTwitterGraphqlExecuteResponseInput = z.input<typeof AdminTwitterGraphqlExecuteResponseSchema>;
export type AdminTwitterGraphqlExecuteResponseOutput = z.output<typeof AdminTwitterGraphqlExecuteResponseSchema>;

export function serializeAdminTwitterGraphqlExecuteResponse(
  payload: AdminTwitterGraphqlExecuteResponseInput
): AdminTwitterGraphqlExecuteResponseOutput {
  return AdminTwitterGraphqlExecuteResponseSchema.parse(payload);
}

export type AdminTwitterFetchTimelineResponseInput = z.input<typeof AdminTwitterFetchTimelineResponseSchema>;
export type AdminTwitterFetchTimelineResponseOutput = z.output<typeof AdminTwitterFetchTimelineResponseSchema>;

export function serializeAdminTwitterFetchTimelineResponse(
  payload: AdminTwitterFetchTimelineResponseInput
): AdminTwitterFetchTimelineResponseOutput {
  return AdminTwitterFetchTimelineResponseSchema.parse(payload);
}
